// Something one part of the app prepares for a form another part opens, like
// an invite Laila drafted for the full invite dialog. It stays in memory, not
// in the URL, since it may hold phone numbers or emails, and is taken once.
export const createHandoff = <T>() => {
  let pending: T | null = null;
  return {
    put: (value: T) => {
      pending = value;
    },
    take: (): T | null => {
      const value = pending;
      pending = null;
      return value;
    },
  };
};
